<template>
    <v-form-tile>
        <h2 slot="title">Payment Preferences</h2>
        <p slot="description" class="text-muted">An order creates an invoice (and if it has subscription items, it
            will create multiple invoices, over time). This section determines how payment should be collected, and
            if there is any changes to trial settings or coupons to apply.</p>
        <div slot="content" class="tile">
            <div class="tile-title">
                <h3>AutoPay</h3>
            </div>
            <div class="tile-content">
                <p class="stack-m">When Autopay is on, a payment will be collected automatically at the invoice due
                    time.</p>
                <div class="grid-content">
                    <div class="grid-item grid-item-half grid-item-break-half">
                        <v-radio
                            class="stack-m"
                            label="On"
                            :value="true"
                            @update="updateAutopay"
                            :model="order.autopay"
                            group="autoplayGroup"/>
                        <v-radio
                            label="Off"
                            :value="false"
                            @update="updateAutopay"
                            :model="order.autopay"
                            group="autoplayGroup"/>
                    </div>
                </div>
            </div>
            <div class="tile-title">
                <h3>Trial</h3>
            </div>
            <div class="tile-content">
                <p class="stack-m">If you want to override the trial settings of the plans, check the box below and fill
                    out the
                    form that displays.</p>
                <div class="grid-content">
                    <div class="grid-item grid-item-half grid-item-break-half">
                        <v-checkbox
                            label="Override trial settings"
                            :value="false"
                            v-model="overrideTrial"
                            :disabled="order.isOneTime"
                        />
                    </div>
                    <template v-if="!overrideTrial">
                        <div class="grid-item grid-item-half grid-item-break-half">
                            <v-date-input
                                label="Trial Ends"
                                type="datetime"
                                v-model="trialEndTime"
                                :validate="validate.trial"
                            />
                        </div>
                    </template>
                </div>
            </div>
            <div class="tile-title">
                <h3>Coupons</h3>
            </div>
            <div class="tile-content" v-if="coupons.length > 0">
                <div class="grid-content">
                    <div class="grid-item grid-item-primary">
                        <v-select
                            placeholder="Search coupons"
                            :value="selectedCoupons"
                            :multiple="true"
                            :allow-empty="true"
                            :options="couponList"
                            @input="updateSelectedCoupons"
                        ></v-select>
                    </div>
                </div>
            </div>
            <div class="tile-content" v-else>
                <div class="grid-content">
                    <div class="grid-item grid-item-half grid-item-break-half">
                        <p class="text-muted">No coupons available</p>
                    </div>
                </div>
            </div>
        </div>
    </v-form-tile>
</template>

<script>
    import {
        vCheckbox, vDateInput, vFormTile, vRadio, vSelect,
    } from '@/components/form';

    export default {
        name: 'payment-preferences',
        props: {
            order: {
                type: Object,
                default: null,
            },
            coupons: {
                type: Array,
                default: null,
            },
            validate: {
                type: Object,
            },
        },
        components: {
            vFormTile,
            vRadio,
            vCheckbox,
            vDateInput,
            vSelect,
        },
        data() {
            return {
                hasTrial: false,
                selectedCoupons: [],
            };
        },
        computed: {
            overrideTrial: {
                get() {
                    return this.order.trial === null;
                },
                set(value) {
                    this.$emit('has-trial',
                               !value ? null : {
                                   enabled: true,
                                   endTime: null,
                               });
                },
            },
            trialEndTime: {
                get() {
                    if (!this.order.trial.endTime) {
                        this.order.trial.endTime = this.$tz().now().add(1, 'day').startOf('day')
                            .format();
                    }
                    return this.$tz().readUTC(this.order.trial.endTime);
                },
                set(value) {
                    this.$emit('has-trial', {
                        enabled: true,
                        endTime: this.order.trial.endTime = value.format(),
                    });
                },
            },
            couponList() {
                return this.coupons.map(coupon => coupon.redemptionCode);
            },
        },
        methods: {
            updateAutopay(value) {
                this.$emit('autopay', value);
            },
            updateSelectedCoupons(coupouns) {
                this.$emit('coupons', coupouns);
                this.selectedCoupons = coupouns;
            },
        },
    };
</script>
